import React from "react";
import InfoCard2 from "../../Common/InfoCard2";
import FullWidthHeading from "../../Device/FullWidthHeading";
import { VisualizationAndNavigationData } from "../../../assets/json/VisualizationAndNavigationData";

const VisualizationAndNavigation = () => {
  return (
    <>
      
      {/* <div className="visualization-and-navigation real-time-attendance"> */}
      <div className="visualization-and-navigation">
        <div className="container">
          <div className="row">
            <div className="com-lg-12">
              <FullWidthHeading
                title={"Visualization and Navigation"}
                data={
                  ' <p class="fs-16 text-center "> Create public announcements, bulletin board management, and more with the best HR <br /> management software. </p>'
                }
              />
            </div>
          
            {VisualizationAndNavigationData.map((item, index) => (
              <div key={index} className="col-lg-4 mb-4">
                <InfoCard2
                  id={item.id}
                  icon={item.icon}
                  title={item.title}
                  desc={item.desc}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default VisualizationAndNavigation;
